import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Toaster } from "@/components/ui/sonner";

function TitleSetter() {
  const location = useLocation();
  useEffect(() => {
    document.title = "Dr. Syvanna";
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen" style={{ backgroundColor: "#FFFCEF" }}>
      <BrowserRouter>
        <TitleSetter />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
